var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8334 0.833374H3.16675C2.50371 0.833374 1.86782 1.09677 1.39898 1.56561C0.93014 2.03445 0.666748 2.67033 0.666748 3.33337V11.6667C0.666748 12.3297 0.93014 12.9656 1.39898 13.4345C1.86782 13.9033 2.50371 14.1667 3.16675 14.1667H14.8334C15.4965 14.1667 16.1323 13.9033 16.6012 13.4345C17.07 12.9656 17.3334 12.3297 17.3334 11.6667V3.33337C17.3334 2.67033 17.07 2.03445 16.6012 1.56561C16.1323 1.09677 15.4965 0.833374 14.8334 0.833374ZM3.16675 2.50004H14.8334C15.0544 2.50004 15.2664 2.58784 15.4227 2.74412C15.579 2.9004 15.6667 3.11236 15.6667 3.33337L9.00008 7.40004L2.33341 3.33337C2.33341 3.11236 2.42121 2.9004 2.57749 2.74412C2.73377 2.58784 2.94573 2.50004 3.16675 2.50004ZM15.6667 11.6667C15.6667 11.8877 15.579 12.0997 15.4227 12.256C15.2664 12.4122 15.0544 12.5 14.8334 12.5H3.16675C2.94573 12.5 2.73377 12.4122 2.57749 12.256C2.42121 12.0997 2.33341 11.8877 2.33341 11.6667V5.23337L8.56675 9.04171C8.69343 9.11485 8.83713 9.15335 8.98341 9.15335C9.12969 9.15335 9.2734 9.11485 9.40008 9.04171L15.6667 5.23337V11.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.a901fae30c44cebaa7fe72557c622637.svg";
export { ForwardRef as ReactComponent };